import { useState, useEffect } from "react";
import { Auth } from "aws-amplify";

import { useAuth, isTreezSSOEnabled } from "auth";

const useUser = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { user: authUser, accountId, storeId } = useAuth();
    const [user, setUser] = useState();

    useEffect(() => {
        if (isTreezSSOEnabled) return;
        setLoading(true);
        Auth.currentAuthenticatedUser()
            .then(cognitoUser => {
                let payload = cognitoUser.signInUserSession.idToken.payload;

                let user = {
                    accountId: payload["custom:ACCOUNT_ID"],
                    storeId: payload["custom:STORE_ID"],
                    roles: payload["cognito:groups"],
                    email: cognitoUser.attributes.email,
                    id: cognitoUser.attributes.sub,
                };

                setUser(user);
                setLoading(false);
            })
            .catch(err => {
                setLoading(false);
                setError(err);
            });
    }, []);

    useEffect(() => {
        const user = {
            accountId: accountId,
            storeId: storeId,
            roles: [authUser?.role],
            email: authUser?.email,
            id: authUser?.id,
        };
        setUser(user);
    }, [authUser, accountId, storeId]);

    return { loading, error, ...user };
};

export default useUser;
